import { logError } from '@/logger'

import { type Brand } from '../types'

export type RecentBrand = Pick<Brand, 'id' | 'name'> & {
  assets: Pick<Brand['assets'], 'logo'>
}

const RECENT_BRANDS_KEY = 'OWNER_RECENT_BRANDS'

const MAX_RECENT_BRANDS = 8

export const setRecentBrands = (value: RecentBrand[]): void => {
  localStorage.setItem(RECENT_BRANDS_KEY, JSON.stringify(value))
}

export const getRecentBrands = (): RecentBrand[] => {
  try {
    const storedBrands = localStorage.getItem(RECENT_BRANDS_KEY)

    if (storedBrands) {
      return JSON.parse(storedBrands)
    } else {
      return []
    }
  } catch (error) {
    logError(error)

    return []
  }
}

export const saveToRecentBrands = (newBrand: RecentBrand): void => {
  const storedBrands = getRecentBrands()

  localStorage.setItem(
    RECENT_BRANDS_KEY,
    JSON.stringify(
      [
        newBrand,
        ...storedBrands.filter((brand) => brand.id !== newBrand.id),
      ].slice(0, MAX_RECENT_BRANDS)
    )
  )
}

export const removeFromRecentBrands = (brandId: string): void => {
  setRecentBrands(getRecentBrands().filter((brand) => brand.id !== brandId))
}
